import { TextSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { useEffect } from 'react'

export function useAutoFocus(view: EditorView, autoFocus: boolean) {
  useEffect(() => {
    if (autoFocus) {
      const intervalId = setInterval(() => {
        const proseElement = document.querySelector('.ProseMirror')
        const emptyLine = document.querySelector('.EmptyPrompt')

        // We want to focus the last line on new docs (which might have a title) but docs with existing content can just focus at top of editor
        // Simple check to avoid focusing on the last line of a document that is long and might cause scrolling to selection
        const docTooLongForEmptyLine = view.state.doc.content.content.length > 2
        if (proseElement && !emptyLine && !docTooLongForEmptyLine) {
          const newSelection = TextSelection.create(view.state.doc, view.state.doc.content.size - 1)

          const tr = view.state.tr.setSelection(newSelection)

          view.dispatch(tr)
        }
        if (emptyLine || docTooLongForEmptyLine) {
          view.focus()
        }
        if (view.hasFocus()) clearInterval(intervalId)
      }, 200)
    }
  }, [autoFocus, view])
}
